import { IBudgetVersionServiceItem } from '../../../../../models/budgetV2';

// Items from the loaded budget may come without `id`; fall back to `ref`, which is never reused
// on edit (existing items are flagged as removed instead of dropped, and new ones get a `temp-item-*` id).
export const findInitialServiceItem = (
  initialItems: IBudgetVersionServiceItem[] | undefined,
  item: IBudgetVersionServiceItem | undefined
): IBudgetVersionServiceItem | undefined => {
  if (!item || !initialItems?.length) return undefined;
  if (item.id) {
    const byId = initialItems.find((i) => i.id === item.id);
    if (byId) return byId;
  }
  if (item.id?.startsWith('temp-item-')) return undefined;
  return item.ref ? initialItems.find((i) => !i.id && i.ref === item.ref) : undefined;
};
